import type React from 'react';
import { Box, Typography } from '@mui/material';
import InfoOutlined from '@mui/icons-material/InfoOutlined';
import DOMPurify from 'dompurify';
import { BlurredBackground, OverlayContent, OverlayContentTitle } from './styles';
import { useTranslation } from 'react-i18next';

type ConditionalOverlayProps = {
  children?: React.ReactNode;
  title?: string;
  description?: string;
  contactMessage?: string;
  showOverlay?: boolean;
};

export const ConditionalOverlay = ({ children, showOverlay = false, title, description }: ConditionalOverlayProps) => {
  const { t } = useTranslation(['common']);

  if (!showOverlay) {
    return children ? <>{children}</> : null;
  }

  return (
    <Box sx={{ position: 'relative', width: '100%' }}>
      {children && <Box>{children}</Box>}
      <BlurredBackground />
      <OverlayContent>
        <Box sx={{ marginBottom: 2 }}>
          <InfoOutlined sx={{ fontSize: 60 }} />
        </Box>
        <Box sx={{ maxWidth: '400px' }}>
          <OverlayContentTitle variant="h3">{title ?? t('overlay.section disabled')}</OverlayContentTitle>
          <Typography
            variant="body1"
            sx={{ fontSize: '1rem', color: 'inherit' }}
            dangerouslySetInnerHTML={{
              __html: DOMPurify.sanitize(description ?? t('overlay.your company is not subscribed to this product'))
            }}
          ></Typography>
        </Box>
      </OverlayContent>
    </Box>
  );
};
